// CustomerCompanyContext.js
import { createContext } from 'react';

const CustomerCompanyContext = createContext({
  currentCustomer: null,
  availableCustomers: [],
  setCurrentCustomer: () => {},
  setAvailableCustomers: () => {}
});

export default CustomerCompanyContext;
